import React, { useCallback, useContext } from 'react'

import GeoContext from 'contexts/geoContext'
import ExperienceBookmarkCard from 'tripPlanner/components/Bookmark/BookmarkCard/ExperienceBookmarkCard'
import TripItemCarousel from 'tripPlanner/components/Bookmark/Carousels/TripItemCarousel'
import { useTripId } from 'tripPlanner/contexts/TripContext'
import { useExperiences } from 'tripPlanner/hooks/api/offer'
import useImmersiveModeHandlers from 'tripPlanner/hooks/useImmersiveModeHandlers'

type Props = {
  offerIds: Array<string>
  ctaCard?: React.ReactElement
  parentLoading?: boolean
  sectionId: string
}

function ExperienceItemCarousel({
  ctaCard,
  offerIds,
  parentLoading,
  sectionId,
}: Props) {
  const { currentCurrency, currentRegionCode } = useContext(GeoContext)

  const { setImmersiveMode } = useImmersiveModeHandlers()
  const { data: experienceOffers, isLoading: isExperienceLoading } =
    useExperiences({
      experienceIds: offerIds,
      currentCurrency,
      currentRegionCode,
    })

  const tripId = useTripId()
  const onExperienceClick = useCallback(() => {
    setImmersiveMode({
      sectionId,
      tripId,
    })
  }, [sectionId, tripId, setImmersiveMode])

  return (
    <TripItemCarousel isLoading={isExperienceLoading || !!parentLoading}>
      {experienceOffers.map((experienceOffer) => (
        <ExperienceBookmarkCard
          key={experienceOffer.id}
          experience={experienceOffer}
          onClick={onExperienceClick}
        />
      ))}
      {ctaCard}
    </TripItemCarousel>
  )
}

export default ExperienceItemCarousel
